import { createContext } from 'react';

import { LessonContextType } from '@/types/types';

const LessonContext = createContext<LessonContextType | undefined>(undefined);

export default LessonContext;
